/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { AnyObjectSchema, ValidationError } from "yup";

import { FormManagerErrors, ResolverCreator } from "./types";

const yupResolver: ResolverCreator<AnyObjectSchema> =
    (schema) => async (values) => {
        try {
            const data = await schema.validate(values, { abortEarly: false });

            return { data, errors: null };
        } catch (err) {
            if (!(err instanceof ValidationError)) {
                return { errors: {}, data: null };
            }

            if (!err.inner) {
                throw err;
            }

            const errors: FormManagerErrors = {};

            for (const { message, path } of err.inner) {
                if (!path) {
                    continue;
                }

                if (!errors[path]) {
                    errors[path] = [];
                }

                errors[path].push(message);
            }

            return { errors, data: null };
        }
    };

export default yupResolver;
